//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConditionSingleValueInput from "./value-inputs/condition-single-value-input";
import ConditionMultiValueInput from "./value-inputs/condition-multi-value-input";
import ConditionMultiOptionInput from "./value-inputs/condition-multi-option-input";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentValueInput",
  components: {
    ConditionSingleValueInput,
    ConditionMultiValueInput,
    ConditionMultiOptionInput
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    values: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    inputType: {
      type: String,
      required: true
    },
    valueType: {
      type: String,
      required: true
    },
    conditionName: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    selectId() {
      return `value-select-${this.index}`;
    },
    componentInput() {
      return `condition-${this.inputType}-input`;
    }
  },
  methods: {
    handleChange(data, type) {
      this.$emit("change", {
        data,
        type
      });
    }
  }
});